import { Select } from "@mui/material";
import React, { useContext } from "react";
import { ReportParameterModifierTypes } from "../../../../logic/api";
import { SessionContext } from "../../../../utility/useSession";
import { formatCamel } from "../../../../utility/utils";


const ReportParameterModifierField: React.FunctionComponent<{
    label: string,
    value?: ReportParameterModifierTypes;
    onChange: (value: ReportParameterModifierTypes) => void;
}> = (props) => {
    const session = useContext(SessionContext);



    const selectedReportTypeId = props.value != null
        ? props.value
        : -1;

    const reportTypeNames = [];
    for (const a in ReportParameterModifierTypes) {
        if (isNaN(parseInt(a)) == true) {
            reportTypeNames.push(a);
        }
    }


    return <Select
        native
        style={{ width: "100%", maxWidth: 225, borderRadius: 5, padding: 5 }}

        value={selectedReportTypeId}
        onChange={(e) => {
            props.onChange(parseInt(String(e.target.value), 10));
        }}
    >

        {session.current.site != null && reportTypeNames.map((item, i) => {
            return <option key={i} value={i} title={item}>{formatCamel(item)}</option>;
        })}

    </Select>;
}

export default ReportParameterModifierField;